import Cookies from 'universal-cookie';
import useApi from '../hooks/useApi';
import { parseFiveYearCutoverDetails } from './fiveYearCutover';

const CACHE_TTL_MS = 30000;

/** @type {Map<string, { details: object, cachedAtMs: number }>} */
const cacheByUserId = new Map();
/** @type {Map<string, Promise<object>>} */
const inflightByUserId = new Map();

function getCurrentUserId() {
  const cookies = new Cookies();
  return cookies.get('_Id') || cookies.get('userid') || cookies.get('userId') || '';
}

export function clearFiveYearCutoverCache(userId) {
  if (userId) {
    cacheByUserId.delete(userId);
    inflightByUserId.delete(userId);
    return;
  }
  cacheByUserId.clear();
  inflightByUserId.clear();
}

export async function getFiveYearCutoverDetails(options = {}) {
  const { forceRefresh = false } = options;
  const userId = getCurrentUserId();
  const now = Date.now();
  const cached = cacheByUserId.get(userId);

  if (!forceRefresh && cached && now - cached.cachedAtMs < CACHE_TTL_MS) {
    return cached.details;
  }

  const inflight = inflightByUserId.get(userId);
  if (!forceRefresh && inflight) {
    return inflight;
  }

  const request = (async () => {
    const response = await useApi('IS_FIVE_YEAR_CUTOVER_PENDING', {}, {}, ['_Id']);
    const details = parseFiveYearCutoverDetails(response);
    cacheByUserId.set(userId, { details, cachedAtMs: Date.now() });
    return details;
  })();

  inflightByUserId.set(userId, request);
  try {
    return await request;
  } finally {
    inflightByUserId.delete(userId);
  }
}
